<template>
  <v-select
    hide-details="auto"
    chips
    small-chips
    :deletable-chips="true"
    multiple
    outlined
    dense
    :menu-props="{ offsetY: true }"
    :clearable="true"
    v-bind="$attrs"
    v-on="$listeners"
    :class="{ 'small-input': small }"
  ></v-select>
</template>

<script>
export default {
  props: {
    small: {
      Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-select__selections {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
::v-deep .v-select__selections input {
  max-height: 0px !important;
}
::v-deep .v-select__selections {
  gap: 2px;
}
.small-input {
  ::v-deep .v-select__selections {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
  ::v-deep .v-chip.v-size--small {
    border-radius: 12px;
    font-size: 10px;
    height: 20px;
  }
}
</style>
